// extracted by mini-css-extract-plugin
export default {"app-bar__watermark--dev":"AppBar_app-bar__watermark--dev__w-f-B","app-bar__watermark--demo":"AppBar_app-bar__watermark--demo__3Al9P"};